module.exports = __webpack_public_path__ + "assets/img/43@3x.fc64348d.png";